import PropTypes from 'prop-types';
import React from 'react';
import _ from 'underscore';

import BenchlingConfig from 'BenchlingConfig';
import {pluralize} from 'BenchlingUtil';
import ModalButtonKey from 'test/lib/cypress/shared/ModalButtonKey';
import {ButtonStyle} from 'ui-library/buttons/Button';
import Modal from 'ui-library/modals/Modal';
import {SelectOptionModalBody} from 'ui-library/modals/SelectOptionModal';
import {getWorkflowDisplayString} from 'workflows/util/WorkflowUtil';

import {EXECUTION_TYPES, ExecutionType} from './ExecuteRequestFlowConstants';

interface SelectExecutionTypePaneProps {
  requestIds: Array<string>;
  selectedExecutionType: ExecutionType | null;
  isFirstPane: boolean;
  onGoToNextPane: () => void;
  onGoToPrevPane: () => void;
  onRequestClose: () => void;
  onSetExecutionType: (executionType: ExecutionType) => void;
}

function SelectExecutionTypePane(props: SelectExecutionTypePaneProps): JSX.Element {
  return (
    <Modal
      buttons={_.compact([
        !props.isFirstPane && {
          key: 'back',
          text: 'Back',
          className: 'u-mini-spacing-right',
          style: ButtonStyle.TERTIARY_GRAY,
          onClick: props.onGoToPrevPane,
          dataTestAttrs: {
            component: 'SelectExecutionTypePane',
            element: 'footerButton',
            key: ModalButtonKey.BACK,
          },
        },
        {
          text: 'Next',
          key: 'next',
          style: ButtonStyle.PRIMARY,
          onClick: props.onGoToNextPane,
          disabled: !props.selectedExecutionType,
          dataTestAttrs: {
            component: 'SelectExecutionTypePane',
            element: 'footerButton',
            key: ModalButtonKey.NEXT,
          },
        },
      ])}
      onRequestClose={props.onRequestClose}
      showFooterBorder={false}
      title={`Execute ${pluralize(props.requestIds.length, 'request')} as...`}
      wrapInForm={false}
      large={true}
    >
      <SelectOptionModalBody
        options={[
          ...(BenchlingConfig.ELN_ENABLE_BLANK_ENTRY_CREATION
            ? [{value: EXECUTION_TYPES.ENTRY, text: 'Entry'}]
            : []),
          {value: EXECUTION_TYPES.ENTRY_TEMPLATE, text: 'Entry from template'},
          {value: EXECUTION_TYPES.EXISTING_ENTRY, text: 'Existing entry'},
          {value: EXECUTION_TYPES.WORKFLOW, text: getWorkflowDisplayString('Legacy Workflow', 'Workflow')},
        ]}
        selectedOption={props.selectedExecutionType}
        onSelectOption={props.onSetExecutionType}
      />
    </Modal>
  );
}

SelectExecutionTypePane.propTypes = {
  requestIds: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
  selectedExecutionType: PropTypes.oneOf(Object.values(EXECUTION_TYPES)),
  isFirstPane: PropTypes.bool.isRequired,
  onGoToNextPane: PropTypes.func.isRequired,
  onGoToPrevPane: PropTypes.func.isRequired,
  onRequestClose: PropTypes.func.isRequired,
  onSetExecutionType: PropTypes.func.isRequired,
};

export default SelectExecutionTypePane;
